module.exports = __webpack_public_path__ + "static/media/panic-mode.88a55b14.svg";